import { useFeatureValue } from '@growthbook/growthbook-react';
import { TargetingProvider } from '@openx/components-targeting/utils/context/TargetingContext';
import { ALLOWLIST_APP_INVENTORY, ENABLED_APP_INVENTORY } from '@openx/constants/feature-flag-keys';
import { useEmailAllowlist } from '@openx/utils/hooks/useEmailAllowlist';
import { OPEN_AUDIENCE_ORG_NAME } from '@openx/utils/services/config';
import type { PropsWithChildren } from 'react';
import { useAuth } from '../../../components/AuthContext/context';
import { GROWTHBOOK_SALT } from '../../../config';
import { targetingConfig } from '../targetingConfig';

export const TargetingProviderWithAuth = ({ children }: PropsWithChildren) => {
  const { session } = useAuth();

  const isOaSuborg = session?.account?.name !== OPEN_AUDIENCE_ORG_NAME;

  // App Inventory feature flags
  const isAppInventoryEnabled = useFeatureValue(ENABLED_APP_INVENTORY, false);
  const allowListAppInventory: string = useFeatureValue(ALLOWLIST_APP_INVENTORY, '');

  const { inAllowList: inAllowListAppInventory } = useEmailAllowlist({
    email: session?.email,
    allowList: allowListAppInventory,
    salt: GROWTHBOOK_SALT,
  });

  // Allow if: feature enabled AND (no allowlist OR user is in allowlist)
  const isAppInventoryAllowed = isAppInventoryEnabled && (!allowListAppInventory.length || inAllowListAppInventory);

  return (
    <TargetingProvider
      targetingConfig={{
        ...targetingConfig,
        isOaSuborg,
        isAppInventoryAllowed,
      }}
    >
      {children}
    </TargetingProvider>
  );
};
